import React, { useState } from 'react'
import useMediaQuery from '../utils/useMediaQuery'
import Layout from '../shared/components/organisms/layout/layout'
import SEO from '../shared/seo'
import GameContent from '../components/organisms/gameContent/gameContent'
import PageLayout from '../components/templates/page-layout/page-layout'

const JuegoPage = props => {
  const isMobile = useMediaQuery()
  const [modalActive, setModalActive] = useState()

  return (
    <PageLayout hiddenNav={true}>
      <GameContent mobile={isMobile} setModalActive={setModalActive} />
    </PageLayout>
  )
}

export default JuegoPage


